import { lightboxes } from './lightboxes';
import { mobile } from './mobile';
import { nav } from './nav';
import { loader } from './loader';
import { addUpdates } from './add-updates';
import { editUpdates } from './edit-updates';
import { checkIn } from './check-in';
import { pullToRefresh } from './pull-to-refresh';
import { footerMega } from './footer-mega';
import { pushNotifications } from './push';
import { tabNav } from './tab-nav';

const $j = (typeof window !== 'undefined' && (window as Window & { $j: unknown }).$j) || (() => {}) as (s: string) => unknown;
const $ = $j as (s: string) => { removeClass: (c: string) => void };

(function (jq: unknown, _root: unknown) {
    const j = jq as (fn: () => void) => void;
    j(function () {
        $('html').removeClass('no-js');
        lightboxes();
        mobile();
        nav();
        loader();
        addUpdates();
        editUpdates();
        checkIn();
        pullToRefresh();
        footerMega();
        pushNotifications();
        tabNav();
    });
})($j, this);
